<template>
    <van-popup v-model:show="innerVisible" style="background: #f9fafc;" closeable close-icon="clear" round
        position="bottom" class="trade-popup">
        <div class="list">
            <div class="title">{{ title }}</div>

            <div class="item" @click="select(v)" v-for="v in props.list" :key="v.id">
                <div class="lf">
                    <div class="img">
                        <img :src="getImg('pay' + v.id)" alt="" />
                    </div>
                    <span>{{ v.name }}</span>
                </div>
                <van-icon class="icon" name="arrow" />
            </div>

            <!-- <div class="item" @click="select('usdt')">
                <div class="lf">
                    <div class="img">
                        <img src="@/assets/images/uzf.png" alt="" />
                    </div>
                    <span>USDT</span>
                </div>
                <van-icon class="icon" name="arrow" />
            </div> -->
        </div>
    </van-popup>
</template>

<script setup>
import { ref, watch } from "vue";
import { getRecharge } from "@/api"
const props = defineProps({
    title: { type: String, default: "交易类型" },
    list:{type:Array,default:()=>[]},
    modelValue: { type: Boolean, default: false } // ⭐ v-model 绑定字段
});

const emits = defineEmits(["update:modelValue", "select"]);

// 内部可控的可见状态
const innerVisible = ref(props.modelValue);

// 监听父 -> 子
watch(
    () => props.modelValue,
    (val) => {
        innerVisible.value = val;
    }
);

// 监听子 -> 父
watch(innerVisible, (val) => {
    emits("update:modelValue", val);
});

// 点击选项
function select(v) {
    if (v.id == 6) {
        emits("select", {
            type: 'bank',
            item: v
        });
    } else {
        emits("select", {
            type: 'usdt',
            item: v
        });
    }
    innerVisible.value = false; // 自动关闭
}

// const list = ref()
// const getData = async () => {
//     try {
//         const res = await getRecharge({})
//         if (res.code == 200) {
//             list.value = res.data.pay
//         }
//     } catch (error) {

//     }
// }
// getData()

function getImg(name) {
    return new URL(`../../assets/images/${name}.png`, import.meta.url).href;
}
</script>
<style scoped lang="scss">
.list {
    display: flex;
    flex-direction: column;
    gap: 13px;
    padding: 15px 15px 20px;

    .title {
        text-align: center;
        font-size: 18px;
        margin-bottom: 15px;
    }

    .item {
        padding: 0 12px;
        height: 70px;
        border-radius: 10px;
        background: #fff;
        box-shadow: 0px 2px 8px 0px rgba(223, 223, 223, 0.25);
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;

        .lf {
            display: flex;
            align-items: center;

            .img {
                width: 50px;
                height: 50px;
                margin-right: 12px;

                img {
                    width: 100%;
                }
            }

            span {
                color: #000;
                font-family: 'Microsoft YaHei UI';
                font-size: 16px;
                font-style: normal;
                font-weight: 700;
                line-height: normal;
                text-transform: capitalize;
            }
        }

        .icon {
            font-size: 14px;
            color: #333;
        }
    }
}
</style>